import { setIdiomas } from './comun';

export function dispararEvento( elemento, evento ) {
	let evt;
	if ( document.createEventObject ) {			// IE
		evt = document.createEventObject();
		return elemento.fireEvent('on' + evento,evt );
	} else {									// Firefox...
		evt = document.createEvent('HTMLEvents');
		evt.initEvent( evento, true, true );	// Evento tipo, bubbling, cancelable
		return !elemento.dispatchEvent( evt );
	}
}

export function subirHasta( elemento, etiqueta ) {
	etiqueta = etiqueta.toLowerCase();
	while ( elemento && elemento.parentNode ) {
		elemento = elemento.parentNode;
		if ( elemento.tagName && elemento.tagName.toLowerCase() == etiqueta ) {
			return elemento;
		}
	}
	return null;
}

// Copies a string to the clipboard. Must be called from within an 
// event handler such as click. May return false if it failed, but
// this is not always possible. Browser support for Chrome 43+, 
// Firefox 42+, Safari 10+, Edge and IE 10+.
// IE: The clipboard feature may be disabled by an administrator. By
// default a prompt is shown the first time the clipboard is 
// used (per session).
export function copiarAlPortapapeles( text ) {
    if (window.clipboardData && window.clipboardData.setData) {
        // IE specific code path to prevent textarea being shown while dialog is visible.
        return clipboardData.setData("Text", text); 

    } else if (document.queryCommandSupported && document.queryCommandSupported("copy")) {
        let textarea = document.createElement("textarea");
        textarea.textContent = text;
        textarea.style.position = "fixed";  // Prevent scrolling to bottom of page in MS Edge.
        document.body.appendChild(textarea);
        textarea.select();
        try {
            return document.execCommand("copy");  // Security exception may be thrown by some browsers.
        } catch (ex) {
            console.warn("Copy to clipboard failed.", ex);
            return false;
        } finally {
            document.body.removeChild(textarea);
        }
    }
}

export function padIzquierdo( cadenaOrigen, cadenaPadding ) {
	return String( cadenaPadding + cadenaOrigen ).slice( - cadenaPadding.length );
}

export function dbFecha( cadena ) {
	if ( cadena == '' ) return '';
	let anio = cadena.substr(0, 4);
	let mes = cadena.substr(5, 2);
	let dia = cadena.substr(8, 2);
	return dia + '/' + mes + '/' + anio;
};

export function fechaDb( cadena ) {
	if ( cadena == '' ) return '';
	let dia = cadena.substr(0, 2);
	let mes = cadena.substr(3, 2);
	let anio = cadena.substr(6, 4);
	return anio + '-' + mes + '-' + dia;
};

export function dbFechaHora( cadena ) {
	if ( cadena == '' ) return '';
	let fh = cadena.split(' ');
	return dbFecha( fh[0] ) + ' ' + fh[1];
};

export function fechaHora2horaMinutos( cadena ) {
	let fh = cadena.split(' ');
	return fh[1].substr( 0, 5 );
};

export function fechaHoraDb( cadena ) {
	if ( cadena == '' ) return '';
	let fh = cadena.split(' ');
	return fechaDb( fh[0] ) + ' ' + fh[1];
};

//

export let getMesLargo = ( mesNumero, idioma ) => {
	let meses = {
		es: [ "enero", "febrero", "marzo", "abril", "mayo", "junio", "julio", "agosto", "septiembre", "octubre", "noviembre", "diciembre" ],
		en: [ "january", "february", "march", "april", "may", "june", "july", "august", "september", "october", "november", "dicember" ],
		ca: [ "gener", "febrer", "març", "abril", "maig", "juny", "juliol", "agost", "setembre", "octubre", "novembre", "desembre" ],
		fr: [ "janvier", "février", "mars", "avril", "mai", "juin", "juillet", "août", "septembre", "octobre", "novembre", "décembre" ],
		pt: [ "janeiro", "fevereiro", "março", "abril", "maio", "junho", "julho", "agosto", "setembro", "outubro", "novembro", "dezembro" ]
	}
	if ( idioma in meses ) {
		return meses[ idioma ][ mesNumero - 1 ]
	} else {
		return meses[ setIdiomas[0] ][ mesNumero - 1 ]	// Idioma por defecto
	}
}

export let getMesCorto = ( mesNumero, idioma ) => {
	let meses = {
		es: [ "ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic" ],
		en: [ "jan", "feb", "mar", "apr", "may", "jun", "jul", "aug", "sep", "oct", "nov", "dec" ],
		ca: [ "gen", "feb", "mar", "abr", "mai", "jun", "jul", "ago", "set", "oct", "nov", "des" ],
		fr: [ "jan", "fev", "mar", "avr", "mai", "juin", "juil", "aou", "sep", "oct", "nov", "dec" ],
		pt: [ "jan", "fev", "mar", "abr", "mai", "jun", "jul", "ago", "set", "out", "nov", "dez" ]
	}
	if ( idioma in meses ) {
		return meses[ idioma ][ mesNumero - 1 ]
	} else {
		return meses[ setIdiomas[0] ][ mesNumero - 1 ]	// Idioma por defecto
	}
}

export let getFechaMesLargoComaAnio = ( fecha, idioma ) => {
	const aFecha = fecha.split('-')
	return `${parseInt(aFecha[2], 10)} ${getMesLargo(parseInt(aFecha[1], 10), idioma)}, ${aFecha[0]}`
}

export let getFechaMesLargoAnio = ( fecha, idioma ) => {
	const aFecha = fecha.split('-')
	return `${parseInt(aFecha[2], 10)} ${getMesLargo(parseInt(aFecha[1], 10), idioma)} ${aFecha[0]}`
}

export let getFechaDeMesLargoComaAnio = ( fecha, idioma ) => {
	const aFecha = fecha.split('-')
	return `${parseInt(aFecha[2], 10)} de ${getMesLargo(parseInt(aFecha[1], 10), idioma)}, ${aFecha[0]}`
}

export let getFechaDeMesLargoDeAnio = ( fecha, idioma ) => {
	const aFecha = fecha.split('-')
	return `${parseInt(aFecha[2], 10)} de ${getMesLargo(parseInt(aFecha[1], 10), idioma)} de ${aFecha[0]}`
};

export let getFechaMesLargo = ( fecha, idioma ) => {
	const aFecha = fecha.split('-')
	return `${parseInt(aFecha[2], 10)} ${getMesLargo(parseInt(aFecha[1], 10), idioma)}`
}

export let getFechaMesCortoComaAnio = ( fecha, idioma ) => {
	const aFecha = fecha.split('-')
	return `${parseInt(aFecha[2], 10)} ${getMesCorto(parseInt(aFecha[1], 10), idioma)}, ${aFecha[0]}`
}

export let getFechaMesCorto = ( fecha, idioma ) => {
	const aFecha = fecha.split('-')
	return `${parseInt(aFecha[2], 10)} ${getMesCorto(parseInt(aFecha[1], 10), idioma)}`
}

//
export function desplegar( elem, callback ) {
	elem.style.display = 'block';			// Muestra,
	let height = elem.scrollHeight + 'px';	// obtiene alto y
	elem.style.display = '';				// oculta.
	elem.classList.add('desplegado');		// Muestra
	elem.style.height = height;				// Transition height
	elem.style.opacity = '1';				// y opacity 
	window.setTimeout(function () {
		elem.style.height = 'auto';
		if ( typeof callback == 'function') callback();
	}, 300 );
};

export function plegar( elem, callback ) {
	elem.style.height = elem.scrollHeight + 'px';	// Da al elemento el alto inicial de la transition
	window.setTimeout( () => {
		elem.style.height = '0';					// Transition height
		elem.style.opacity = '0';					// y opacity 
	}, 60 );
	window.setTimeout(function () {
		elem.classList.remove('desplegado');		// Oculta al terminar la transition
		if ( typeof callback == 'function') callback();
	}, 300 );
};

export function scrollIt( destination, duration = 200, easing = 'linear', callback ) {
	const easings = {
		linear(t) {
			return t;
		},
		easeInQuad(t) {
			return t * t;
		},
		easeOutQuad(t) {
			return t * (2 - t);
		},
		easeInOutQuad(t) {
			return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
		},
		easeInCubic(t) {
			return t * t * t;
		},
		easeOutCubic(t) {
			return (--t) * t * t + 1;
		},
		easeInOutCubic(t) {
			return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
		},
		easeInQuart(t) {
			return t * t * t * t;
		},
		easeOutQuart(t) {
			return 1 - (--t) * t * t * t;
		},
		easeInOutQuart(t) {
			return t < 0.5 ? 8 * t * t * t * t : 1 - 8 * (--t) * t * t * t;
		},
		easeInQuint(t) {
			return t * t * t * t * t;
		},
		easeOutQuint(t) {
			return 1 + (--t) * t * t * t * t;
		},
		easeInOutQuint(t) {
			return t < 0.5 ? 16 * t * t * t * t * t : 1 + 16 * (--t) * t * t * t * t;
		}
	};
	const start = window.pageYOffset;
	const startTime = 'now' in window.performance ? performance.now() : new Date().getTime();
	const documentHeight = Math.max(document.body.scrollHeight, document.body.offsetHeight, document.documentElement.clientHeight, document.documentElement.scrollHeight, document.documentElement.offsetHeight);
	const windowHeight = window.innerHeight || document.documentElement.clientHeight || document.getElementsByTagName('body')[0].clientHeight;
	const destinationOffset = typeof destination === 'number' ? destination : destination.offsetTop;
	const destinationOffsetToScroll = Math.round(documentHeight - destinationOffset < windowHeight ? documentHeight - windowHeight : destinationOffset);
	if ('requestAnimationFrame' in window === false) {
		window.scroll(0, destinationOffsetToScroll);
		if ( callback ) {
			callback();
		}
		return;
	}
	function scroll() {
		const now = 'now' in window.performance ? performance.now() : new Date().getTime();
		const time = Math.min(1, ((now - startTime) / duration));
		const timeFunction = easings[easing](time);
		window.scroll(0, Math.ceil((timeFunction * (destinationOffsetToScroll - start)) + start));
		if (window.pageYOffset === destinationOffsetToScroll) {
			if (callback) {
				callback();
			}
			return;
		}
		requestAnimationFrame(scroll);
	}
	scroll();
};
